<template>
  <div
      v-loading="loading"
      element-loading-text="玩命加载中……"
      element-loading-spinner="el-icon-loading">
    <el-row :gutter="15" style="margin-bottom: 8px">
      <el-col :span="18" :offset="3">
        <el-input placeholder="请输入客户名称" v-model="searchCondition.name" class="input-with-select"
                  @change="searchCustomer" clearable>
          <el-button slot="append" icon="el-icon-search" @click="searchCustomer">搜索客户</el-button>
        </el-input>
      </el-col>
    </el-row>
    <div class="default-table">
      <el-table
          :data="tableData"
          style="width: 100%"
          height="360"
          highlight-current-row
          @row-click="selectRow"
          header-row-class-name="tbl-header">
        <el-table-column
            width="80"
            label="序号">
          <template slot-scope="scope">
            <span>{{ offset + scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="客户名称"
            prop="name"
            header-align="center"
            align="left"
            min-width="200"
        >
          <template slot-scope="{row}">
            <el-link type="primary" icon="el-icon-thumb">{{ row.name }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
            label="开拓者"
            prop="pioneer_name"
            align="center"
            min-width="100"
        >
          <template slot-scope="{row}">
            <span>{{ row.pioneer_name || '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="集团名称" align="center" min-width="120" show-overflow-tooltip="">
          <template slot-scope="{row}">
            <span>{{ row.combine ? row.combine.name : '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column
            label="添加日期"
            width="180">
          <template slot-scope="{row}">
            <i class="el-icon-time"></i>
            <span style="margin-left: 10px">{{ row.created_at }}</span>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
          v-show="total>0"
          :total="total"
          :page.sync="searchCondition.page"
          :limit.sync="searchCondition.per_page"
          @pagination="queryCustomer"
      />
    </div>
  </div>
</template>

<script>
import {searchCustomer} from "@/api/customers";

export default {
  name: "CustomerSelect",
  props: {
    name: {
      type: String,
      default() {
        return ''
      }
    }
  },
  data() {
    return {
      loading: true,
      offset: 0,
      total: 0,
      searchCondition: {
        name: null, page: 1, per_page: 10
      },
      tableData: [],
    }
  },
  mounted() {
    this.searchCondition.name = this.name
    this.queryCustomer()
  },
  methods: {
    // ------ 分页相关 ---------
    getPagingInfo() {
      return {
        per_page: this.searchCondition.per_page,
        page: this.searchCondition.page
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {}
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name
      }
      return condition
    },
    queryCustomer() {
      this.loading = true
      let pagingInfo = this.getPagingInfo()
      let searchCondition = this.handleSearchCondition()
      Object.assign(searchCondition, pagingInfo)
      searchCustomer(searchCondition).then(res => {
        this.loading = false
        let pageData = res.model
        this.tableData = pageData.data
        this.searchCondition.per_page = pageData.per_page
        this.total = pageData.total
        this.offset = (pageData.current_page - 1) * pageData.per_page
      });
    },
    searchCustomer() {
      this.searchCondition.page = 1
      this.queryCustomer()
    },
    selectRow(row, column) {
      // e.preventDefault();//阻止元素发生默认的行为
      if (column.property === 'name') {
        this.$emit('selectRow', row)
      }
    },
  }
}
</script>